import { Url } from '../../../../shared/constant/url.constant';

/**
 * Route utilisées pour les fees & benefits.
 */
export namespace ConstantSourceForm {
  export const data = {
    title: 'Source Form',
    sub: {
      lister: 'Lister',
      ajouter: 'Ajouter',
      ajout: {
        title: 'Ajout d\'un Source Form'
      },
      liste: 'Liste',
      list: {
        title: 'Liste des Source Form'
      }
    }

  }
  export const url = {
    FEES: {
      FEES_: 'source-form',
      LIST: 'liste',
      ADD: 'add'
    }
  };

  export const urlFull = {
    FEES: {
      ADD: ConstantSourceForm.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantSourceForm.url.FEES.ADD),
      LIST: ConstantSourceForm.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantSourceForm.url.FEES.LIST),
    }
  };
}
